import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-fcm',
	template: ''
})
export class FcmComponent implements OnInit {

	constructor(private activatedroute: ActivatedRoute, private router: Router) { }

	ngOnInit() {
		this.router.navigate(['main/home']);
	}

}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/fcm/fcm.component.ts